
import React, { useEffect, useState, useRef } from "react";
import API from "../Services/Auth"
import API1 from "../Services/Inventory"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import APISS from '../Services/Location'
import LocationList from "../Components/Location";
import Select from "react-select";

const IngredientList = () => {

    const [ingredient, setIngredient] = useState([]);
    const [name, setName] = useState("");
    const [measurementUnit, setMeasurementUnit] = useState("");
    const [status, setStatus] = useState("");
    const [createdAt, setCreatedAt] = useState("");
    const [measurementUnits, setMeasurementUnits] = useState([]);
    const [openingStock, setOpeningStock] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const perPage = 10;
    const [id, setId] = useState([])
    const [locationId, setLocationId] = useState("");
    const [errors, setErrors] = useState({});
    const [search, setSearch] = useState("")
    const [unitName, setUnitName] = useState("")

    const [locationName, setLocationName] = useState("")
    const [selectedLocation, setSelectedLocation] = useState("");
    const [location, setLocation] = useState([])


    useEffect(() => {
        bindMeasurementUnit();
        bindInventoryList();
        bindLocation();
    }, [currentPage])


    const bindLocation = async () => {
        try {
            const response = await APISS.getLocationList({
                is_active: 1,
                limit: 0,
            });
            setLocation(response?.data?.data || []);
        } catch (error) {
            //setError("Failed to fetch locations.");
            console.error(error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
        }
    };


    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value?.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }
        switch (fieldName) {
            case "name":
                setName(value);
                break;
            case "measurementUnit":
                setMeasurementUnit(value);
                break;
            case "openingStock":
                setOpeningStock(value);
                break;
            default:

                break;
            case "selectedLocation":
                setSelectedLocation(value);
                break;
        }
    };

    const bindMeasurementUnit = async (type = null) => {
        let payload = {
            is_active: 1
        }
        if (type != null) {
            payload = {
                is_active: 1,
               // type  (when show only selected unit then uncomment this type)
            }
        }
        const response = await API.bindMeasurementUnit(payload)
        setMeasurementUnits(response.data.data.rows)
        //console.log('response.data.data.rows',response.data.data);

    }

    const bindInventoryList = async () => {
        try {
            const payload = {
                page_number: currentPage,
                limit: perPage,
                is_recipe: 0,
                search: search,
                ...(selectedLocation && { location_id: selectedLocation })
            };
            const response = await API1.Get_inventory_List(payload);
            const details = response?.data;
            setTotalRecords(details?.totalCount);
            setIngredient(details?.data)
        } catch (error) {
            toast.dismiss();
            if (!error.response) {
                toast.error("Network error! Please check your internet connection");
            } else if (error.response.status === 403) {
                window.location.replace("/Login")
                toast.error("Network error! Please check your internet connection.");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };

    const totalPages = Math.ceil(totalRecords / perPage);
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            // bindInventoryList();
        }
    };
    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);
            if (left > 2) {
                pageNumbers.push(1, '...');
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }
            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }
            if (right < totalPages - 1) {
                pageNumbers.push('...', totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }
        return pageNumbers;
    };

    const handleGetData = async (id) => {
        try {
            setId(id);
            const response = await API1.Get_inventory_List({ id: id });
            const fetchedData = response?.data?.data?.[0];
            // console.log('fetchedData', fetchedData);
            if (fetchedData) {
                bindMeasurementUnit(fetchedData?.unit)
                // setHighlight(true);
                setName(fetchedData?.name);
                setOpeningStock(fetchedData?.qty)
                setMeasurementUnit(fetchedData?.unit)
                setStatus(fetchedData?.is_active);
                setCreatedAt(fetchedData?.createdAt);
                setUnitName(fetchedData?.unit_name)
                //setIsEditing(true);
                setLocationName(fetchedData?.location_name)
                setLocationId(fetchedData?.location_id)

            } else {
                toast.error("Failed to fetch designation details.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching data:", error);
        }
    };

    const handleStatusToggle = async (id, currentStatus) => {
        const updatedStatus = !currentStatus;
        try {
            const response = await API1.updateIngredientStatus(id);
            if (response.status === 200) {
                setIngredient((prevLocation) =>
                    prevLocation.map((item) =>
                        item.id === id ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(response.data.message);
                bindInventoryList();
            } else {
                toast.error("Error updating status:", response);
                toast.error("Failed to update the status. Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found.');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.log("Error in status toggle:", error);
            toast.error("Failed to update the status. Please try again.");
        }
    };
    const handleUpdate = async () => {

        const nameRegex = /^[A-Za-z\s]+$/;
        const stockRegex = /^[0-9]+$/;
        let errors = {};
        if (!name?.trim()) {
            errors.name = "Name is required";
            toast.error(errors.name);
            return;
        } else if (!nameRegex.test(name)) {
            errors.name = "Name can only contain letters";
            toast.error(errors.name);
            return;
        }
        if (!measurementUnit) {
            toast.error('Measurement unit is required.');
            return;
        }
    
        const payload = {
            name: name,
            unit: measurementUnit,
           // qty: openingStock,
            sale_product_id: 0,
            location_id: parseInt(locationId)
        };
       // console.log(payload)
        // return;

        try {
            const response = await API1.Update_inventory(id, payload);
            if (response?.status === 200) {
                toast.success(response.data.message);
                bindInventoryList();
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(`Unexpected status: ${response.status} - ${response.data.message}`);
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    toast.error('Resource not found (404)');
                } else {
                    toast.error(`Error: ${error.response.data.message || 'Something went wrong'}`);
                    console.error('Error response:', error.response);
                }
            } else if (error.request) {
                console.error('No response received:', error.request);
                toast.error('No response from the server. Please try again.');
            } else {
                if (error.response.status === 404) {
                    toast.error('Resource not found');
                }
                else if (error.response.status === 403) {
                    window.location.replace("/Login");
                }
                console.error('Error:', error.message);
                toast.error('An error occurred. Please try again.');
            }
        }
    };

    const handleCancel = () => {
        setTimeout(() => window.location.reload());
    }
    const handleFieldChange1 = (e, fieldName) => {
        const value = e.target.value;
        if (fieldName === "search") {
            setSearch(value);
            if (value.trim() === "") {
                setCurrentPage(1);
                bindInventoryList(1);
            }
        }
    };

    const handleSearch = () => {
        if (search.trim() === "") {
            setCurrentPage(1);
            bindInventoryList(1);  // Fetch all records
        } else {
            setCurrentPage(1);
            bindInventoryList(1);
        }
    };
    const locationOptions = location.map((item) => ({
        value: item.id,
        label: item.name,
    }));
    return (
        <div>
            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Total Ingredient</h4>
                    </div>
                    <div className="card-body">
                        <div className="row mb-3 align-items-end">
                            <div className="col-md-4">
                                <label className="form-label">
                                    <b>Search by Name</b>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by Name"
                                    value={search}
                                    onChange={(e) => handleFieldChange1(e, "search")}
                                />
                            </div>

                            <div className="col-md-3">
                                <button
                                    onClick={handleSearch}
                                    className="btn btn-success"
                                    type="button"
                                >
                                    Search
                                </button>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>SrNo</th>
                                        <th>Action</th>
                                        <th>Name</th>
                                        {/* <th>Center Name</th> */}
                                        <th>Measurement Unit</th>
                                        {/* <th>Current Stock</th> */}
                                        <th>Status</th>
                                        <th>Created-Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ingredient && ingredient.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>{(currentPage - 1) * perPage + index + 1}</td>

                                            <td>
                                                <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                    <ul className="navbar-nav navbar-nav-right">
                                                        <li className="nav-item nav-profile1">
                                                            <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <div className="nav-profile-text1">
                                                                    <p className="mb-1 text-black">
                                                                    </p>
                                                                </div>
                                                            </span>
                                                            <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                            <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalView">
                                                                        View
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)}
                                                                        className="btn btn-primary btn-sm" type="button"
                                                                        data-bs-toggle="modal" data-bs-target="#myModalEdit"
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">

                                                                    <button
                                                                        className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                                        onClick={() => handleStatusToggle(item.id, item.is_active)}
                                                                    >
                                                                        {item.is_active ? "De-Activated" : "Activate"}
                                                                    </button>

                                                                </a>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>
                                            <td>{item.name}</td>
                                            {/* <td>{item.location_name}</td> */}
                                            <td>{item.unit_name}</td>
                                            {/* <td>{item.qty}</td> */}
                                            <td>{item?.is_active ? "Active" : "De-Activated"}</td>
                                            <td>
                                                {moment(item.createdAt).format("DD-MM-YYYY")}

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination justify-content-center mt-4">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Previous
                                        </button>
                                    </li>

                                    {getPageNumbers().map((page, index) => (
                                        <li
                                            key={index}
                                            className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                        >
                                            {page === "..." ? (
                                                <span className="page-link">...</span>
                                            ) : (
                                                <button className="page-link" onClick={() => handlePageChange(page)}>
                                                    {page}
                                                </button>
                                            )}
                                        </li>
                                    ))}
                                    <li
                                        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <section>
                <div className="modal" id="myModalView">
                    <div className="modal-dialog  modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Ingredient Details</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <table class="table table-bordered border-secondary">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Center Name</th>
                                            <th>Measurement Unit</th>

                                        </tr>
                                        <tr>
                                            <td>{name}</td>
                                            <td>{locationName}</td>
                                            <td>{unitName}</td>

                                        </tr>
                                        <tr>
                                            <th>Current Stock</th>
                                            <th>Status</th>
                                            <th>Created Date</th>
                                        </tr>

                                        <tr>
                                            <td>{openingStock}</td>
                                            <td>{status ? "Active" : "De-Activated"}</td>
                                            <td>{moment(createdAt).format("DD-MM-YYYY")}</td>
                                        </tr>

                                    </thead>
                                </table>
                            </div>
                            <div className="modal-footer">

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="modal" id="myModalEdit" data-bs-backdrop="static">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Update Ingredient</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <div>
                                    <div className="row mb-3">

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="txtname" className="form-label">
                                                    Name <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control ${errors.name ? "is-invalid" : ""}`}
                                                    id="txtname"
                                                    placeholder="Name"
                                                    value={name}
                                                    onChange={(e) => handleFieldChange(e, "name")}
                                                />
                                                {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="ddMeasurementUnit" className="form-label">
                                                    Measurement Unit <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <select
                                                    className={`form-select ${errors.measurementUnit ? "is-invalid" : ""}`}
                                                    id="ddMeasurementUnit"
                                                    //disabled={true}
                                                    value={measurementUnit}
                                                    onChange={(e) => handleFieldChange(e, "measurementUnit")}
                                                >
                                                    <option value="">Select Unit </option>
                                                    {measurementUnits.map((unit) => (
                                                        <option key={unit.id} value={unit.id}>
                                                            {unit.name}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.measurementUnit && (
                                                    <div className="invalid-feedback">{errors.measurementUnit}</div>
                                                )}
                                            </div>
                                        </div>

                                        {/* <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor="txtstock" className="form-label">
                                                    Opening Stock <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control ${errors.openingStock ? "is-invalid" : ""}`}
                                                    id="txtstock"
                                                    placeholder="Stock"
                                                    value={openingStock}
                                                    onChange={(e) => handleFieldChange(e, "openingStock")}
                                                />
                                                {errors.openingStock && (
                                                    <div className="invalid-feedback">{errors.openingStock}</div>
                                                )}
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <div className="mt-3">

                                        <button
                                            type="button"
                                            onClick={handleUpdate}
                                            className="btn btn-primary me-2"
                                        //  style={{ display: isEditing ? "inline-block" : "none" }}
                                        >
                                            Update
                                        </button>

                                        <button onClick={handleCancel} className="btn btn-light ms-2">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section >



        </div >

    );
};

export default IngredientList;

